<template>
  <v-dialog v-model="valueProxy" width="90%" max-width="500px">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-card min-height="250">
        <v-card-title>
          <span class="mainTitle" style="font-size: 20px">
            {{ 'Checkout' }}
          </span>
          <v-spacer />
          <v-btn icon @click="valueProxy = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form v-if="step === 0">
            <v-row align="baseline">
              <v-col cols="6">Payment method:</v-col>
              <v-col cols="6">Cash</v-col>
            </v-row>
            <v-row align="baseline">
              <v-col cols="6">Received Amount:</v-col>
              <v-col cols="6">
                <ValidationProvider
                  :rules="{ required: true, min_value: data.amountPayable }"
                  v-slot="{ errors }"
                  name="Received amount"
                >
                  <v-text-field
                    flat
                    outlined
                    prefix="$"
                    v-model.number="receivedAmount"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
          <v-form v-if="step === 1">
            <v-row align="baseline">
              <v-col cols="6">Order Number:</v-col>
              <v-col cols="6">{{ get(data, 'sid', '-') }}</v-col>

              <v-col cols="6">Payment date:</v-col>
              <v-col cols="6">{{ new Date() | moment }}</v-col>

              <v-col cols="6">Payment method:</v-col>
              <v-col cols="6">{{ get(data, 'paymentMethod', '-') }}</v-col>

              <v-col cols="6" class="text-h6">Total amount:</v-col>
              <v-col cols="6" class="text-h6 primary--text">{{
                get(data, 'amountPayable', 0) | currency
              }}</v-col>
              <template v-if="isCashPayment">
                <v-col cols="6">Received amount:</v-col>
                <v-col cols="6" class="font-weight-bold">{{ receivedAmount | currency }}</v-col>
              </template>
            </v-row>
            <v-row v-if="isCashPayment" class="mt-8 secondary--text">
              <v-col cols="6">Change</v-col>
              <v-col cols="6" class="font-weight-bold">{{ changeAmount | currency }}</v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="doClose()">Cancel</v-btn>
          <v-btn color="primary" @click="confirm()" :loading="loading" :disabled="invalid">
            {{ step === 0 ? 'Next' : 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import CustomLabel from '@/components/customFormLabel/customLabel';
import { paymentOfOthers } from '@/data/constants';
import { get } from 'lodash';
export default {
  name: 'ProductOrderCheckoutDialog',
  components: {
    CustomLabel,
  },
  props: {
    value: {},
    data: {},
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentOfOthers,
      step: 0,
      receivedAmount: 0,
    };
  },
  watch: {
    value: {
      handler(v) {
        if (v) {
          this.step = this.isCashPayment ? 0 : 1; // payment
        }
      },
    },
    'data.amountPayable': {
      handler(v) {
        this.receivedAmount = Number(v) || 0;
      },
      immediate: true,
    },
  },
  computed: {
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        if (!value) {
          this.$emit('close');
        }
      },
    },
    isCashPayment() {
      return this.data.paymentMethod === paymentOfOthers.cash;
    },
    changeAmount() {
      return +(this.receivedAmount - this.data.amountPayable).toFixed(2);
    },
  },
  methods: {
    get,
    doClose() {
      this.valueProxy = false;
    },
    async confirm() {
      if (!(await this.$refs.form.validate())) return;
      if (this.step === 0) {
        this.step++;
        return;
      }
      let additionalDate = {
        sid: this.data.sid,
      };
      if (this.isCashPayment) {
        additionalDate = Object.assign(additionalDate, {
          receivedAmount: this.receivedAmount,
          changeAmount: this.changeAmount,
        });
      }

      this.$emit('confirm', additionalDate);
    },
  },
};
</script>

<style lang="scss" scoped></style>
